<div class="module-container" [ngStyle]="customStyle" [ngClass]="type">
  <div class="module-title" *ngIf="title">
    <span>{{ title }}</span>
  </div>
  <ng-content></ng-content>
</div>
